import io from "socket.io-client";

//const rootUrl = "http://webjob-admin.devari.com.br";
//const rootUrl = "http://localhost:8000";
const rootUrl = "https://admin.consultazap.com.br";
export const baseUrl = `${rootUrl}/api/v1`;

export const socket = io.connect(rootUrl);

export const EVENTS = {
  HAS_ENTERED: "has_entered",
  HAS_LEFT: "has_left",
  SEND_PING: "send_ping",
};
